import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  createSkillsListOperationsAtom,
  createSkillsListMetricsAtom,
} from './atoms'
import { StartAndMonitorFlow } from '../../contentService/FlowStartandMonitor'
import { doTreeOperationsJob } from '../../contentService/utility'

interface CreateSkillsListProps {
  treeId: string
  versionId: string
}

export function CreateSkillsList({ treeId, versionId }: CreateSkillsListProps) {
  const operations = useAtomValue(createSkillsListOperationsAtom)
  const { nodesToUpdate, totalQuestions } = useAtomValue(
    createSkillsListMetricsAtom,
  )

  const startFlowFunction = async (): Promise<string> => {
    const result = await doTreeOperationsJob(operations)
    if (!result.result?.data?.flow_id) {
      throw new Error('No flow ID received from API')
    }
    return result.result.data.flow_id
  }

  return (
    <Paper elevation={2} sx={{ padding: 2, marginTop: 2 }}>
      <Typography variant="h6" gutterBottom>
        Create Missing Skill Lists
      </Typography>
      <Box sx={{ marginTop: 1 }}>
        <Typography>
          <strong>Nodes to be updated:</strong> {nodesToUpdate}
        </Typography>
        <Typography>
          <strong>Questions that would receive new Skill Lists:</strong>{' '}
          {totalQuestions}
        </Typography>
        {nodesToUpdate === 0 && (
          <Typography color="text.secondary" sx={{ marginTop: 1 }}>
            All questions already have Skill Lists. No new Skill Lists need to
            be created.
          </Typography>
        )}
        <Typography
          color="text.secondary"
          sx={{ marginTop: 1, fontStyle: 'italic' }}
        >
          Reset Tree when this operation is completed.
        </Typography>
      </Box>
      <Box sx={{ marginTop: 2 }}>
        <StartAndMonitorFlow
          disabled={nodesToUpdate === 0}
          buttonText="Create Skill Lists"
          processingText="Creating Skill Lists..."
          startFlowFunction={startFlowFunction}
          pollingIntervalMs={2000}
          downloadResults={true}
        />
      </Box>
    </Paper>
  )
}
